// extracted by mini-css-extract-plugin
module.exports = {"sliderHandles":"_e9b28fc","button":"_7edab5a","hideArrows":"_1be88d0","show":"_c5b73a0","right":"_b09e84f"};